import React from 'react';
import { Typography } from '@sm/wds-react';
import { Card } from '@wds/card';
import { Box } from '@wds/box';
import { withWebAssetsTheme } from '../../theme';
import useStyles from './useStyles';

export type ClientErrorProps = {
  openingMessage: string;
  errorTitle: string;
  titularElementTag: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'div';
  children?: React.ReactNode;
};

// Exported as a named-component for use without ThemeProvider
export function ClientError({
  openingMessage,
  errorTitle,
  titularElementTag = 'p',
  children,
}: ClientErrorProps) {
  const { wrapper, cardWrapper } = useStyles();
  return (
    <div className={wrapper} data-testid="ClientError">
      <div>
        <Typography variant="pageTitle" align="center">
          {openingMessage}
        </Typography>
        <div className={cardWrapper}>
          <Box>
            <Card>
              <Box p={1}>
                <Typography
                  component={titularElementTag}
                  variant="sectionTitle"
                  align="center"
                >
                  {errorTitle}
                </Typography>
              </Box>
              {children}
            </Card>
          </Box>
        </div>
      </div>
    </div>
  );
}

export default withWebAssetsTheme(ClientError);
